import type { ReactNode } from 'react';
import { getObjectId, type Id, type AccountTransaction } from '@hero/schema';
import { useAccountTransactionListApi } from '@hero/api-hooks';
import { AccountTransactionList } from '../../AccountTransaction/List/AccountTransactionList';

export interface InvoiceTransactionsTabProps {
  invoiceId: Id;
  /**
   * Bilateral viewer role on the parent invoice — drives sign /
   * label of each row (debit vs credit copy).
   */
  asRole: 'buyer' | 'seller';
  renderTransaction?: (transaction: AccountTransaction) => ReactNode;
}

/**
 * Lists payment activity for a single bilateral invoice.
 *
 * Reads the bilateral `AccountTransaction` ledger via
 * `useAccountTransactionListApi({ invoiceId })`. The viewer-side
 * role is forwarded so each row can render the sign and copy from
 * the viewer's perspective.
 */
export function InvoiceTransactionsTab({
  invoiceId,
  asRole,
  renderTransaction,
}: InvoiceTransactionsTabProps) {
  const query = useAccountTransactionListApi(
    { invoiceId: getObjectId(invoiceId) },
    { enabled: !!invoiceId },
  );

  void asRole;

  return (
    <AccountTransactionList
      query={query}
      renderTransaction={renderTransaction}
      className="gap-3 p-4"
    />
  );
}
